import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import type { Option } from 'modules/core/components/Popover/Content'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import FileListItem from 'modules/tasks/components/FileListItem'
import type TaskFile from 'modules/tasks/store/models/TaskFile'

interface FileListProps {
  readonly?: boolean
  currentFiles: TaskFile[]
  newFiles: TaskFile[]
  onDeleteExistingFile: (file: TaskFile) => void
  onDeleteNewFile: (file: TaskFile) => void
}

const FileList = ({
  readonly,
  currentFiles,
  newFiles,
  onDeleteExistingFile,
  onDeleteNewFile,
}: FileListProps) => {
  const existingFileOptions = (file: TaskFile): Option[] => [
    {
      href: buildUrl(file.attributes.path),
      title: i18n.t('tasks.actions.attachment.download'),
    },
    ...(readonly
      ? []
      : [
          {
            onClick: () => onDeleteExistingFile(file),
            title: i18n.t('tasks.actions.attachment.delete'),
            type: 'wrong',
          } as const,
        ]),
  ]

  const newFileOptions = (file: TaskFile): Option[] => [
    {
      onClick: () => onDeleteNewFile(file),
      title: i18n.t('tasks.actions.attachment.delete'),
      type: 'wrong',
    },
  ]

  return (
    <BoxList>
      {currentFiles
        .filter((file) => file.has('path'))
        .map((file: TaskFile, index: number) => (
          <FileListItem key={index} fileName={file.filename} options={existingFileOptions(file)} />
        ))}
      {newFiles.map((file: TaskFile, index: number) => (
        <FileListItem key={index} fileName={file.filename} options={newFileOptions(file)} />
      ))}
    </BoxList>
  )
}

export default observer(FileList)
